import React from 'react';
import fr from 'facet-rest';
import { pickWithPriority } from 'Helpers/Affordances';
import ScenarioChart from './ScenarioChart';

// TODO: maybe change the affordance to be the same
const ScenarioChartPicker = props => {
  return pickWithPriority(props.resource, [
    [fr.relationships.facetPlanMultiChartData.name, <ScenarioChart
      {...props}
      test={'facet-plan-multi-chart-data-scenario-chart'}
      query={fr.queries.getFacetPlanMultiChartData.name}
      relationship={fr.relationships.facetPlanMultiChartData.name}
    />],
    [fr.relationships.activeScenarioChartData.name, <ScenarioChart
      {...props}
      test={'active-scenario-chart-data-scenario-chart'}
      isMultiChart={false}
      query={fr.queries.getFacetPlanChartData.name}
      relationship={fr.relationships.activeScenarioChartData.name}
    />],
    [fr.relationships.facetPlanChartData.name, <ScenarioChart
      {...props}
      test={'facet-plan-chart-data-scenario-chart'}
      isMultiChart={false}
      query={fr.queries.getFacetPlanChartData.name}
      relationship={fr.relationships.facetPlanChartData.name}
    />],
    [fr.relationships.facetPlanChartPresentData.name, <ScenarioChart
      {...props}
      test={'facet-plan-chart-present-data'}
      isMultiChart={false}
      query={fr.queries.getFacetPlanChartData.name}
      relationship={fr.relationships.facetPlanChartPresentData.name}
    />],
  ], null);
};

export default ScenarioChartPicker;
